import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartDrawerService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();

  constructor() {}

  open(): void {
    this.isOpenSubject.next(true);
    // Prevent body scroll when drawer is open
    document.body.style.overflow = 'hidden';
  }

  close(): void {
    this.isOpenSubject.next(false);
    // Restore body scroll when drawer is closed
    document.body.style.overflow = '';
  }

  toggle(): void {
    const currentState = this.isOpenSubject.value;
    if (currentState) {
      this.close();
    } else {
      this.open();
    }
  }

  getIsOpen(): boolean {
    return this.isOpenSubject.value;
  }
}

